<template>
    <div>
        <DotStatus
            v-if="showStatus"
            :color="getStatusColorMap(invoiceStatus, invoiceProcessStatus).color"
            :text="getStatusColorMap(invoiceStatus, invoiceProcessStatus).text"
            class="pl-8 pb-1 slightly-bigger"
        />
        <div v-for="(message, idx) in messages" class="d-flex align-center" :key="idx">
            <icon icon="Check" color="tretiary" class="mr-2" />
            <span v-html="message" />
        </div>
    </div>
</template>

<script>
import { $t } from "@/i18n";
import { computed } from "@vue/composition-api";
import {
    formatDateTime,
    formatMoney
} from "@/plugins/formatting";
import DotStatus from '../DotStatus.vue'
import SalesInvoiceModule from "@/store/modules/sales_invoice";
export default {
    name: "InvoiceStatusInfoBlock",
    components: {DotStatus},
    props: {
        exportedAt: {
            type: String,
            default: null
        },
        exportedTo: {
            type: String,
            default: null
        },
        sentAt: {
            type: String,
            default: null
        },
        sentFrom: {
            type: String,
            default: null
        },
        paidAt: {
            type: String,
            default: null
        },
        paidCurrency: {
            type: String,
            default: null
        },
        paidSum: {
            type: Number,
            default: null
        },
        annulledAt: {
            type: String,
            default: null
        },
        showStatus:{
            type: Boolean,
            default: false
        },
        invoiceStatus: {
            type: String,
            default: ''
        },
        invoiceProcessStatus: {
            type: String,
            default: ''
        },
    },
    setup(props, ctx) {
        const exportedMessage = computed(() => {
            if(!props.exportedAt) return null
            return $t('<b>Exported</b> {0} to {1}').format(formatDateTime(props.exportedAt), props.exportedTo)
        })
        const sentMessage = computed(() => {
            if(!props.sentAt) return null
            return $t('<b>Sent to client</b> {0} from {1}').format(formatDateTime(props.sentAt), props.sentFrom)
        })
        const paidMessage = computed(() => {
            if(!props.paidAt) return null
            return $t('<b>Paid {0}</b> {1}').format(formatMoney(props.paidSum, props.paidCurrency), formatDateTime(props.paidAt))
        })
        const annulledMessage = computed(() => {
            if(!props.annulledAt) return null
            return $t('<b>Annulled</b> {0}').format(formatDateTime(props.annulledAt))
        })
        const messages = computed(() =>[
            exportedMessage.value,
            sentMessage.value,
            paidMessage.value,
            annulledMessage.value
        ].filter(x => x))
        const {
            getStatusColorMap,
        } = SalesInvoiceModule();
        return {
            messages,
            getStatusColorMap
        };
    }
};
</script>

<style scoped lang="scss">
.slightly-bigger {
    font-size: 16px!important;
}
.tofrom {
    .comp-data {
        color: var(--v-g5-base);
        line-height: 20px;
    }

    .tofrom-caption {
        text-transform: uppercase;
        color: var(--v-main-base);
    }

    .tofrom-headline {
        font-size: 26px;
        letter-spacing: 0.5px;
    }
}
</style>